module.exports = __webpack_public_path__ + "static/media/hand-with-ruby.ed8b7e2b.svg";